import { Carousel } from 'react-responsive-carousel';

import 'react-responsive-carousel/lib/styles/carousel.css';
import '../styles/whatToKnow.scss';

import carousel1 from '../assets/carousel1.jpg';
import carousel2 from '../assets/carousel2.jpg';
import carousel3 from '../assets/carousel3.jpg';
import arrowLeft from '../assets/arrowLeft.svg';
import arrowRight from '../assets/arrowRight.svg';

const WtkInfoPanelCarousel = ({ icon, pg1, pg2, pq }) => {
  return (
    <div className="wtkPanel">
      <div className="wtkPanel__left">
        <img src={icon} alt="graphic icon" />
        <p>{pg1}</p>
        <p>{pg2}</p>
      </div>
      <div className="wtkPanel__carousel">
        <Carousel
          showStatus={false}
          showThumbs={false}
          infiniteLoop={true}
          showIndicators={false}
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              <button
                type="button"
                onClick={onClickHandler}
                title={label}
                style={{
                  position: 'absolute',
                  zIndex: 2,
                  top: 'calc(50% - 15px)',
                  left: '.5rem',
                  width: 10,
                  height: 20,
                  cursor: 'pointer',
                  background: 'none',
                  border: 'none'
                }}
              >
                <img src={arrowLeft} alt="triangle" />
              </button>
            )
          }
          renderArrowNext={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              <button
                type="button"
                onClick={onClickHandler}
                title={label}
                style={{
                  position: 'absolute',
                  zIndex: 2,
                  top: 'calc(50% - 15px)',
                  right: '.5rem',
                  width: 10,
                  height: 20,
                  cursor: 'pointer',
                  background: 'none',
                  border: 'none'
                }}
              >
                <img src={arrowRight} alt="triangle" />
              </button>
            )
          }
          // renderArrowPrev={(onClickHandler, hasPrev, label) =>
          //   hasPrev && (
          //     <button
          //       type="button"
          //       onClick={onClickHandler}
          //       title={label}
          //       style={{
          //         position: 'absolute',
          //         zIndex: 2,
          //         bottom: '1.5rem',
          //         left: '25%',

          //         width: 80,
          //         height: 10,
          //         cursor: 'pointer',
          //         background: 'none',
          //         border: 'none'
          //       }}
          //     >
          //       BACK |
          //     </button>
          //   )
          // }
          // renderArrowNext={(onClickHandler, hasPrev, label) =>
          //   hasPrev && (
          //     <button
          //       type="button"
          //       onClick={onClickHandler}
          //       title={label}
          //       style={{
          //         position: 'absolute',
          //         zIndex: 2,
          //         bottom: '1.5rem',
          //         right: '32%',

          //         width: 80,
          //         height: 10,
          //         cursor: 'pointer',
          //         background: 'none',
          //         border: 'none'
          //       }}
          //     >
          //       NEXT
          //     </button>
          //   )
          // }
        >
          <div>
            <img src={carousel1} alt="plug graphic" />
            {/* <p className="legend">Legend 1</p> */}
          </div>
          <div>
            <img src={carousel2} alt="plug graphic" />
            {/* <p className="legend">Legend 1</p> */}
          </div>
          <div>
            <img src={carousel3} alt="plug graphic" />
            {/* <p className="legend">Legend 1</p> */}
          </div>
        </Carousel>
      </div>
    </div>
  );
};

export default WtkInfoPanelCarousel;
